export const config = {
  baseURL:
    process.env.API_HOST || 'http://b2cbackendforfront-svc.staging.setur.k8s',
  SENTRY_ENV: process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV,
};
